import { Component, OnInit, Input, EventEmitter, Output, OnChanges } from '@angular/core';

import { BaseComponent } from '~Interfaces/basecomponent';

/**
 * Classe PageEvent
 */
export class PageEvent {
    indexPage: number;
    taillePage: number;
    total: number;
}

/**
 * Composant de pagination
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent extends BaseComponent implements OnInit, OnChanges {
    @Input() titre: string = '';
    @Input() indexPage: number = 0;
    @Input() taillePage: number = 10;
    @Input() total: number = 0;
    @Input() nombrePagesAfficher: number = 3;
    @Input() afficherLesPages: boolean = true;
    @Input() afficherTotal: boolean = true;

    @Output() readonly page: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();

    listePages: number[] = [];
    afficherPremierePage: boolean = false;
    afficherDernierePage: boolean = false;

    /**
     * Constructeur
     */
    constructor() { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        this.emitPageEvent();
    }

    /**
     * Changements
     */
    ngOnChanges() {
        this.calculPages();
    }

    /**
     * Calcul des pages
     */
    public calculPages() {
        if (this.nombrePages <= this.nombrePagesAfficher) {
            this.afficherPremierePage = false;
            this.afficherDernierePage = false;
            let n = this.nombrePages < this.nombrePagesAfficher ? this.nombrePages : this.nombrePagesAfficher;
            this.definirPages(1, n);
        }
        else {
            if (this.numeroPage >= 1 && this.numeroPage <= this.nombrePagesAfficher) {
                this.afficherPremierePage = false;
                this.afficherDernierePage = true;
                this.definirPages(1, this.nombrePagesAfficher);
            }
            else if ((this.nombrePages + 1 - this.nombrePagesAfficher) <= this.numeroPage && this.numeroPage <= this.nombrePages) {
                this.afficherPremierePage = true;
                this.afficherDernierePage = false;
                this.definirPages((this.nombrePages + 1 - this.nombrePagesAfficher), this.nombrePages);
            }
            else {
                this.afficherPremierePage = true;
                this.afficherDernierePage = true;
                this.definirPages(this.numeroPage - Math.floor(this.nombrePagesAfficher / 2), this.numeroPage + Math.floor(this.nombrePagesAfficher/2));
            }
        }
    }

    /**
     * D�finir les pages
     * @param debut
     * @param fin
     */
    public definirPages(debut: number, fin: number) {
        this.listePages = [];
        for (let i = debut; i <= fin; i++) {
            this.listePages.push(i);
        }
    }

    /**
     * Indique si la page pr�c�dente existe
     */
    public get pagePrecedenteExiste(): boolean {
        return this.indexPage >= 1 && this.taillePage != 0;
    }

    /**
     * Indique si la page suivante existe
     */
    public get pageSuivanteExiste(): boolean {
        const maxPageIndex = this.nombrePages - 1;
        return this.indexPage < maxPageIndex && this.taillePage != 0;
    }

    /**
     * Acc�der � la page pr�c�dente
     */
    public pagePrecedente(): void {
        if (!this.pagePrecedenteExiste) { return; }

        this.indexPage--;
        this.emitPageEvent();
    }

    /**
     * Acc�der � la page suivante
     */
    public pageSuivante(): void {
        if (!this.pageSuivanteExiste) { return; }

        this.indexPage++;
        this.emitPageEvent();
    }

    /**
     * D�finit l'index de la page
     * @param indexPage
     */
    public definirIndexPage(indexPage: number): void {
        if (indexPage < 0 || indexPage > (this.nombrePages - 1)) return;

        this.indexPage = indexPage;
        this.emitPageEvent();
    }

    /**
     * Obtenir le num�ro de la page
     */
    public get numeroPage(): number {
        return this.indexPage + 1;
    }

    /**
     * Obtenir le nombre de pages
     */
    public get nombrePages(): number {
        if (!this.taillePage) {
            return 0;
        }

        return Math.ceil(this.total / this.taillePage);
    }

    /**
     * Swipe
     * @param action
     */
    public swipe(action = 'swiperight') {
        // Swipe page suivante
        if (action === 'swipeleft') {
            this.pageSuivante();
        }
        // Swipe page pr�c�dente
        else if (action === 'swiperight') {
            this.pagePrecedente();
        }
    }

    /**
     * Ev�nement de changement de page
     */
    private emitPageEvent() {
        this.page.emit({
            indexPage: this.indexPage,
            taillePage: this.taillePage,
            total: this.total
        });
        this.calculPages();
    }
}
